export default "__VITE_ASSET__CYApeuBR__"